import Box from '@liquidweb-dev/undercurrent/Box';
import ListItem, {
	type ListItemProps,
} from '@liquidweb-dev/undercurrent/ListItem';
import Skeleton from '@liquidweb-dev/undercurrent/Skeleton';
import Stack from '@liquidweb-dev/undercurrent/Stack';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';

import { containerName, containerQueries, gridStyles } from './AssetListItem';
import { assetListItemMenuAreaClasses } from './classNames';

export interface AssetListItemSkeletonProps extends ListItemProps {
	withStatusBadge?: boolean;
	withMenu?: boolean;
}

export const AssetListItemSkeleton = ({
	withStatusBadge,
	withMenu = true,
	sx,
	...rest
}: AssetListItemSkeletonProps) => (
	<ListItem
		sx={combineSx(
			{
				container: containerName,
				containerType: 'inline-size',
				padding: 0,

				...(withStatusBadge && { minHeight: '64px' }),
			},
			sx,
		)}
		{...rest}
	>
		<Box
			sx={combineSx(gridStyles, {
				padding: 200,
				width: '100%',
			})}
		>
			{withStatusBadge && (
				<Skeleton
					variant="circular"
					sx={({ spacing, size }) => ({
						width: size.md,
						height: size.md,
						position: 'absolute',
						top: spacing(200),
						left: spacing(200),
					})}
				/>
			)}

			<Skeleton
				variant="rounded"
				sx={{
					width: '170px',
					height: ({ size }) => size.sm,
					marginLeft: withStatusBadge ? 600 : 0,
					gridArea: 'name',
				}}
			/>

			<Stack
				sx={{
					flexDirection: 'row',
					gap: 300,
					alignItems: 'center',
					gridArea: 'details',
					justifyContent: {
						[containerQueries[0]]: 'start',
						[containerQueries[820]]: 'end',
					},
				}}
			>
				<Skeleton
					variant="rounded"
					sx={{ width: '70px', height: ({ size }) => size.xS }}
				/>
				<Skeleton
					variant="rounded"
					sx={{ width: '110px', height: ({ size }) => size.xS }}
				/>
				<Skeleton
					variant="rounded"
					sx={{ width: '70px', height: ({ size }) => size.xS }}
				/>
				<Skeleton
					variant="rounded"
					sx={{ width: '110px', height: ({ size }) => size.xS }}
				/>
			</Stack>

			{withMenu && (
				<Skeleton
					className={assetListItemMenuAreaClasses.root}
					variant="circular"
					sx={({ size }) => ({
						width: size.xS,
						height: size.xS,
						gridArea: 'menu',
					})}
				/>
			)}
		</Box>
	</ListItem>
);

export default AssetListItemSkeleton;
